import React from 'react';
import './Testimonials.css';
import {Swiper, SwiperSlide} from 'swiper/react';
import profilePic1 from "../../img/profile1.jpg";
import profilePic2 from "../../img/profile2.jpg";
import profilePic3 from "../../img/profile3.jpg";
import profilePic4 from "../../img/profile4.jpg";
import {Pagination} from "swiper";
import 'swiper/css/pagination';
import 'swiper/css'


const Testimonials = () => {
    const clients = [
        {
            img: profilePic1,
            review: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse sodales tristique quam, placerat placerat dui posuere ac. Nam viverra feugiat posuere. Curabitur congue viverra massa eu imperdiet',
        },

        {
            img: profilePic2,
            review: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse sodales tristique quam, placerat placerat dui posuere ac. Nam viverra feugiat posuere. Curabitur congue viverra massa eu imperdiet',
        },

        {
            img: profilePic3,
            review: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse sodales tristique quam, placerat placerat dui posuere ac. Nam viverra feugiat posuere. Curabitur congue viverra massa eu imperdiet',
        },

        {
            img: profilePic4,
            review: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse sodales tristique quam, placerat placerat dui posuere ac. Nam viverra feugiat posuere. Curabitur congue viverra massa eu imperdiet',
        },
    ]
  return (
    <div className='t-wrapper' id = 'Testimonials'>
        <div className='t-heading'>
            <span>Dont't just take my words</span>
            <span>   See what others say</span>
            <div className='blur t-blur1' style= {{background: 'var(--purple)'}}></div>
            <div className='blur t-blur2' style= {{background: 'skyblue'}}></div>
        </div>

        <Swiper
         modules={[Pagination]}
        slidesPerView = {1}
        pagination = {{clickable: true}}
        >
            {clients.map((cleint, index)=>{
                return (
                    <SwiperSlide key={index}>
                        <div className='testimonials'>
                        <img src={cleint.img} alt = ''/>
                        <span>{cleint.review}</span>
                        </div>
                       
                    </SwiperSlide>
                )
            })}

        </Swiper>


    </div>
  )
}

export default Testimonials